export default __webpack_public_path__ + "static/media/flutter.f48d6b5e.svg";